import { createFileRoute } from '@tanstack/react-router'
import RoiCalculator from "@/public/RoiCalculator";

export const Route = createFileRoute('/roi-calculator')({
  component: RouteComponent,
})

function RouteComponent() {
  return <RoiCalculator/>
}
